<template>
  <app-content class="h-panel">
    <div class="flex justify-between mx-16px pt-16px">
      <DropdownCustom ref="assetsParamsDropdown" button class="h-btn-primary" trigger="click" @click.stop="$refs.assetsParamsDropdown.show()">
        <div>{{ manba(params.start).format('YYYY年') }}</div>
        <template #content>
          <Form style="padding: 10px">
            <FormItem class="!pb-5px" label="会计年度">
              <Select :datas="checkDataLists" v-model="params.start" :deletable="false"/>
            </FormItem>
            <FormItem class="!pb-5px">
              <vxe-button status="primary" @click="loadList();" :loading="loading">确定</vxe-button>
              <vxe-button @click="this.$refs.assetsParamsDropdown.hide()">取消</vxe-button>
              <!-- <vxe-button @click="reset">重置</vxe-button> -->
            </FormItem>
          </Form>
        </template>
      </DropdownCustom>
      <div class="float-right flex items-center">
        <div style="padding:0 12px">
          <vxe-switch v-model="isAll" size="mini" @change="loadList()"></vxe-switch>
          <span>包含营业外收入/成本</span>
        </div>
        <vxe-button @click="exportData" icon="fa fa-download" content="导出"/>
        <vxe-button @click="printData" icon="fa fa-print" content="打印"/>
      </div>
    </div>
    <div class="h-panel-body">
      <!--  :tree-config="{transform: true, rowField: 'treeId', parentField: 'parentTreeId',expandAll: true,reserve: true}" -->
      <!--                  是否可以手动展开子节点                                                      默认展开所有节点 reserve是保持节点展开，但是不好用 -->
      <div class="text-center mb-16px font-bold text-20px">{{ title }} 经营状况表</div>
      <vxe-table 
                 show-footer
                 :footer-method="calcTotal"
                 :loading="loading" ref="xTable" :data="dataList" border >
        <vxe-column title="月份" field="Month" align="center" tree-node width="10%"></vxe-column>
        <vxe-column title="收入" field="Revenue" align="right" width="18%"></vxe-column>
        <vxe-column title="成本" field="Cost" align="right" width="18%"/>
        <vxe-column title="费用" field="Expense" align="right"  width="18%"/>
        <vxe-column title="税金" field="Tax" align="right"  width="18%"/>
        <vxe-column title="利润" field="Profit" align="right"  width="18%"/>
      </vxe-table>
    </div>
  </app-content>
</template>

<script>
import BooUtil from "@/views/accountbook/bookUtil";
import accountbook from "@/api/accountbook";
import {downloadBlob} from "download.js";
import {mapGetters, mapState} from "vuex";
import {clone} from "xe-utils";
import setting from "@/api/setting";

export default {
  name: "OperateSubjectBalance",
  data() {
    return {
      tablePrint: {
        // 自定义打印的样式示例
        style: `
          /* 整个表格的基础样式 */
          .vxe-table {
            font-family: "Microsoft YaHei", 微软雅黑, "MicrosoftJhengHei", 华文细黑, STHeiti, MingLiu; // 设置表格整体字体
          }

          /* 表头单元格 */
          .vxe-table thead th {
            border: 1px solid #000;
            font-size: 14px;
            word-break: break-all;
            overflow-wrap: break-word;
          }

          /* 表体单元格（即数据行的所有单元格） */
          .vxe-body--column, 
          .vxe-table tbody td {
            border: 1px solid #000;
            font-size: 12px;
            word-break: break-all;
            overflow-wrap: break-word;
          }
          /* 表尾单元格样式 */
          .vxe-table tfoot td {
            border: 1px solid #000;
            font-size: 12px;
          }
        `,
        beforePrintMethod: ({ content }) => {
          const headerHtml = `<h3>经营状况表</h3>
            <div style="display:flex;justify-content: space-between;height:22px;line-height:22px">
                <span>编制单位：${this.currentAccountSets.companyName}</span>
                <span> ${this.title} </span>
                <span> 单位：元 </span>
            </div>
          `;
          const footerHtml = ``;
          return `${headerHtml}${content}${footerHtml}`;
        },
      },
      isAll: false,
      dataList:[],
      checkDataLists: [],
      params: {
        start: null,
        accountStandard:null,
      },
    }
  },
  computed: {
    ...mapState(['currentAccountSets']),
    ...mapGetters(['checkoutSelect', 'localCurrency']),
    title() {
			if (!this.params.start) {
				return '';
			}
			return manba(this.params.start).format("YYYY年")
		},
  },
  watch: {

  },
  methods: {
    printData() {
      // 获取VXE-Table实例
      const xTable = this.$refs.xTable;
      // 调用打印方法，并传入打印配置
      xTable.print({
        ...this.tablePrint,
      });
    },
    exportData() {
      const utils = new BooUtil(this.$refs.xTable, '\n')
      accountbook.download({header: utils.header, dataList: utils.dataList}).then((data) => {
        downloadBlob(`${this.title}-经营状况表.xls`, data)
      })
    },
    calcTotal({columns, data}) {
      let formatter = new Intl.NumberFormat('en-US', {  
        minimumFractionDigits: 2,  
        maximumFractionDigits: 2,  
        style: 'decimal', // 或者使用'currency'并设置currency属性为'USD'等，但注意这会添加货币符号  
      });
      const row = [];
      columns.forEach(col => {
        if ('Revenue' === col.property) {  
          let allAmountMonth = 0;
          this.dataList.forEach(item => {
            let num = Number(item.Revenue.replace(/,/g, ''));
            allAmountMonth += Number(num);
          })
          row.push(col.property === "Revenue" ? formatter.format(allAmountMonth) != 0 ? formatter.format(allAmountMonth) : "" : "")
        }else if('Cost' === col.property){
          let allAmountMonth = 0;
          this.dataList.forEach(item => {
            let num = Number(item.Cost.replace(/,/g, ''));
            allAmountMonth += Number(num);
          })
          row.push(col.property === "Cost" ? formatter.format(allAmountMonth) != 0 ? formatter.format(allAmountMonth) : ""  : "")
        }else if('Expense' === col.property){
          let allAmountMonth = 0;
          this.dataList.forEach(item => {
            let num = Number(item.Expense.replace(/,/g, ''));
            allAmountMonth += Number(num);
          })
          row.push(col.property === "Expense" ? formatter.format(allAmountMonth) != 0 ? formatter.format(allAmountMonth) : ""  : "")
        }else if('Tax' === col.property){
          let allAmountMonth = 0;
          this.dataList.forEach(item => {
            let num = Number(item.Tax.replace(/,/g, ''));
            allAmountMonth += Number(num);
          })
          row.push(col.property === "Tax" ? formatter.format(allAmountMonth) != 0 ? formatter.format(allAmountMonth) : ""  : "")
        }else if('Profit' === col.property){
          let allAmountMonth = 0;
          this.dataList.forEach(item => {
            let num = Number(item.Profit.replace(/,/g, ''));
            allAmountMonth += Number(num);
          })
          row.push(col.property === "Profit" ? formatter.format(allAmountMonth) != 0 ? formatter.format(allAmountMonth) : ""  : "")
        }else {
          row.push(col.property === "Month" ? '合计' : "")
        }
      })
      return [row];
    },
    loadList(){
      this.$api.accountbook.loadOperateSubjectBalance({
          start:manba(this.params.start).startOf(manba.MONTH).format("YYYY-DD"),
          //end:manba(this.params.start).endOf(manba.MONTH).format("YYYY-MM-DD"),
          accountStandard:this.currentAccountSets.accountStandard
        }).then(({data}) => {
          let formatter = new Intl.NumberFormat('en-US', {  
            minimumFractionDigits: 2,  
            maximumFractionDigits: 2,  
            style: 'decimal', // 或者使用'currency'并设置currency属性为'USD'等，但注意这会添加货币符号  
          });  
          let arr = [];
          for(let i=1;i<=12;i++){
            let obj = {"Month":i+"月","Revenue":0,"Cost":0,"Expense":0,"Tax":0,"Profit":0};
            data.forEach(item => {
              //小企业
              if(this.currentAccountSets.accountStandard == "SMALL_BUSINESS"){
                //计算收入
                if((item.subjectCode == "5001" || item.subjectCode == "5051") && item.period == i){
                  if(item.balanceDirection == "借"){
                    obj.Revenue += (item.debit - item.credit + Number(item.cfCredit));
                  }else{
                    obj.Revenue += (item.credit - item.debit + Number(item.cfDebit));
                  }
                }
                if(this.isAll){
                  if(item.subjectCode == "5301" && item.period == i){
                    if(item.balanceDirection == "借"){
                      obj.Revenue += (item.debit - item.credit + Number(item.cfCredit));
                    }else{
                      obj.Revenue += (item.credit - item.debit + Number(item.cfDebit));
                    }
                  }
                }
                //计算成本
                if((item.subjectCode == "5401" || item.subjectCode == "5402") && item.period == i){
                  if(item.balanceDirection == "借"){
                    obj.Cost += (item.debit - item.credit + Number(item.cfCredit));
                  }else{
                    obj.Cost += (item.credit - item.debit + Number(item.cfDebit));
                  }
                }
                if(this.isAll){
                  if(item.subjectCode == "5711" && item.period == i){
                    if(item.balanceDirection == "借"){
                      obj.Cost += (item.debit - item.credit + Number(item.cfCredit));
                    }else{
                      obj.Cost += (item.credit - item.debit + Number(item.cfDebit));
                    }
                  }
                }
                //计算Expense
                if((item.subjectCode == "5601" || item.subjectCode == "5602" || item.subjectCode == "5603") && item.period == i){
                  if(item.balanceDirection == "借"){
                    obj.Expense += (item.debit - item.credit + Number(item.cfCredit));
                  }else{
                    obj.Expense += (item.credit - item.debit + Number(item.cfDebit));
                  }
                }
                //计算税金
                if(item.subjectCode == "5403" && item.period == i){
                  if(item.balanceDirection == "借"){
                    obj.Tax += (item.debit - item.credit + Number(item.cfCredit));
                  }else{
                    obj.Tax += (item.credit - item.debit + Number(item.cfDebit));
                  }
                }
              }

              //企业
              if(this.currentAccountSets.accountStandard == "BUSINESS"){
                //计算收入
                if((item.subjectCode == "6001" || item.subjectCode == "6051") && item.period == i){
                  if(item.balanceDirection == "借"){
                    obj.Revenue += (item.debit - item.credit + Number(item.cfCredit));
                  }else{
                    obj.Revenue += (item.credit - item.debit + Number(item.cfDebit));
                  }
                }
                if(this.isAll){
                  if(item.subjectCode == "6301" && item.period == i){
                    if(item.balanceDirection == "借"){
                      obj.Revenue += (item.debit - item.credit + Number(item.cfCredit));
                    }else{
                      obj.Revenue += (item.credit - item.debit + Number(item.cfDebit));
                    }
                  }
                }
                //计算成本
                if((item.subjectCode == "6401" || item.subjectCode == "6402") && item.period == i){
                  if(item.balanceDirection == "借"){
                    obj.Cost += (item.debit - item.credit + Number(item.cfCredit));
                  }else{
                    obj.Cost += (item.credit - item.debit + Number(item.cfDebit));
                  }
                }
                if(this.isAll){
                  if(item.subjectCode == "6711" && item.period == i){
                    if(item.balanceDirection == "借"){
                      obj.Cost += (item.debit - item.credit + Number(item.cfCredit));
                    }else{
                      obj.Cost += (item.credit - item.debit + Number(item.cfDebit));
                    }
                  }
                }
                //计算Expense
                if((item.subjectCode == "6601" || item.subjectCode == "6602" || item.subjectCode == "6603") && item.period == i){
                  if(item.balanceDirection == "借"){
                    obj.Expense += (item.debit - item.credit + Number(item.cfCredit));
                  }else{
                    obj.Expense += (item.credit - item.debit + Number(item.cfDebit));
                  }
                }
                //计算税金
                if(item.subjectCode == "6403" && item.period == i){
                  if(item.balanceDirection == "借"){
                    obj.Tax += (item.debit - item.credit + Number(item.cfCredit));
                  }else{
                    obj.Tax += (item.credit - item.debit + Number(item.cfDebit));
                  }
                }
              }

              //农合计算
              if(this.currentAccountSets.accountStandard == "FARMER"){
                //计算收入
                if((item.subjectCode == "501" || item.subjectCode == "502") && item.period == i){
                  if(item.balanceDirection == "借"){
                    obj.Revenue += (item.debit - item.credit + Number(item.cfCredit));
                  }else{
                    obj.Revenue += (item.credit - item.debit + Number(item.cfDebit));
                  }
                }
                //计算成本
                if(item.subjectCode == "521" && item.period == i){
                  if(item.balanceDirection == "借"){
                    obj.Cost += (item.debit - item.credit + Number(item.cfCredit));
                  }else{
                    obj.Cost += (item.credit - item.debit + Number(item.cfDebit));
                  }
                }
                //计算Expense
                if((item.subjectCode == "523" || item.subjectCode == "524") && item.period == i){
                  if(item.balanceDirection == "借"){
                    obj.Expense += (item.debit - item.credit + Number(item.cfCredit));
                  }else{
                    obj.Expense += (item.credit - item.debit + Number(item.cfDebit));
                  }
                }
                //计算税金
                if(item.subjectCode == "522" && item.period == i){
                  if(item.balanceDirection == "借"){
                    obj.Tax += (item.debit - item.credit + Number(item.cfCredit));
                  }else{
                    obj.Tax += (item.credit - item.debit + Number(item.cfDebit));
                  }
                }
              }
            })
            obj.Profit = Number(obj.Revenue) - Number(obj.Cost) - Number(obj.Expense) - Number(obj.Tax);
            obj.Profit = obj.Profit != 0 ? formatter.format(obj.Profit) : "";
            obj.Revenue = obj.Revenue != 0 ? formatter.format(obj.Revenue) : "";
            obj.Cost = obj.Cost != 0 ?formatter.format(obj.Cost) : "";
            obj.Expense = obj.Expense != 0 ? formatter.format(obj.Expense) : '';
            obj.Tax = obj.Tax != 0 ? formatter.format(obj.Tax) : "";
            arr.push(obj);
          }
          console.log(arr)
          this.dataList = arr;
          this.$refs.assetsParamsDropdown.hide()
        }).finally(() => {
          this.loading = false;
        });
    },
    getUniqueYearsInRange(startDateStr, endDateStr) {
      const startDate = new Date(startDateStr);
      const endDate = new Date(endDateStr);
      
      let uniqueYears = [];
      for (let year = startDate.getFullYear(); year <= endDate.getFullYear(); year++) {
          uniqueYears.push(year);
      }
      let uniqueYearsObj = [];
      uniqueYears.forEach(item => {
        let obj = {"key":`${item}`,"title":item+"年"}
        uniqueYearsObj.push(obj);
      })
      
      this.checkDataLists = uniqueYearsObj || [];
      this.params.start = this.checkDataLists[this.checkDataLists.length - 1].key;
    },
  },
  created() {
    this.getUniqueYearsInRange(this.currentAccountSets.enableDate, this.currentAccountSets.currentAccountDate);
    this.loadList();
  }
}
</script>

<style scoped lang="less">

</style>


<script setup>
import manba from 'manba'
</script>
